<template>
  <div>
    <ViewOneSubscriptionPlan :plan="selectedPlan" />
    <b-modal
      id="status-confirmation"
      ref="statusModal"
      hide-footer
    >
      <template #modal-title>
        Confirm Status Change
      </template>
      Are you sure you want to
      <strong>{{ selectedPlan && selectedPlan.is_active ? 'deactivate' : 'activate' }}</strong>
      this plan?

      <b-row class="mt-2">
        <b-col md="6">
          <b-button
            variant="outline-warning"
            block
            @click="$bvModal.hide('status-confirmation')"
          >
            Cancel
          </b-button>
        </b-col>
        <b-col md="6">
          <b-button
            block
            :disabled="modalLoading"
            variant="primary"
            @click="togglePlanStatus"
          >
            <b-spinner
              v-if="modalLoading"
              small
            />
            <span v-else>Yes, Confirm</span>
          </b-button>
        </b-col>
      </b-row>
    </b-modal>
    <b-card>
      <b-overlay
        variant="white"
        spinner-variant="primary"
        blur="0"
        opacity=".75"
        rounded="sm"
        :show="loadingPlans"
      >
        <b-row class="mb-1">
          <b-col md="4">
            <label
              for="target"
              class="mr-1"
            >Search by target</label>
            <v-select
              id="target"
              v-model="currTarget"
              :clearable="false"
              :options="targetOptions"
              :reduce="(val) => val.key"
              @input="search"
            />
          </b-col>
          <b-col md="4">
            <b-form-group label="Is Active">
              <b-form-checkbox
                v-model="queryParams.activeOnly"
                switch
              />
            </b-form-group>
          </b-col>
          <b-col
            class="d-flex justify-content-end align-items-center"
            md="4"
          >
            <b-button
              variant="primary"
              class="mr-1"
              @click="fetchPlans"
            >
              Search
            </b-button>
            <b-button
              v-if="$can('write', 'subscriptions')"
              variant="success"
              @click="$router.push('/subscription-plans/new')"
            >
              Create Subscription
            </b-button>
            <b-button
              class="btn-icon rounded-circle"
              variant="flat-primary"
              @click="fetchPlans"
            >
              <feather-icon icon="RefreshCwIcon" />
            </b-button>
          </b-col>
        </b-row>
        <b-table
          fixed
          :fields="tableColumns"
          :items="list"
          class="mb-2 text-center"
          show-empty
          empty-text="No matching records found"
        >
          <template #cell(name)="data">
            <div v-html="textFormatter(data.item.name)" />
          </template>
          <template #cell(description)="data">
            <div
              v-html="textFormatter(data.item.description)"
            />
          </template>
          <template #cell(is_active)="data">
            <b-badge
              pill
              :variant="`light-${data.item.is_active ? 'success' : 'danger'}`"
              class="text-capitalize"
            >
              {{ data.item.is_active ? 'Yes' : 'No' }}
            </b-badge>
          </template>
          <template #cell(target)="data">
            <b-badge
              pill
              :variant="`light-${data.item.target === 'driver' ? 'success' : 'primary'}`"
              class="text-capitalize"
            >
              {{ data.item.target }}
            </b-badge>
          </template>
          <template #cell(actions)="data">
            <b-button
              v-if="$can('write', 'subscriptions')"
              class="btn-icon rounded-circle"
              :variant="data.item.is_active ? 'flat-danger' : 'flat-success'"
              title="Toggle Status"
              @click="openStatusModal(data.item)"
            >
              <feather-icon :icon="data.item.is_active ? 'XCircleIcon' : 'CheckCircleIcon'" />
            </b-button>
            <b-button
              variant="flat-primary"
              class="btn-icon rounded-circle"
              @click="viewPlanDetails(data.item)"
            >
              <feather-icon icon="EyeIcon" />
            </b-button>
          </template>
        </b-table>
        <base-pagination
          v-model="queryParams.page"
          :total="total"
          @input="fetchUsers"
          @new-per-page="queryParams.perPage = $event"
        />
      </b-overlay>
    </b-card>
  </div>
</template>

<script>

import {
  BButton, BTable, BCard, BOverlay,
  BBadge,
  BRow, BCol,
  BFormGroup,
  BModal,
  BSpinner,
  BFormCheckbox,
} from 'bootstrap-vue'
import vSelect from 'vue-select'
import useSubscription from '../hooks/use-subscription-plans'
import ViewOneSubscriptionPlan from '../components/view-one-subscription-plan.vue'
import BasePagination from '@/UI/BasePagination.vue'

export default {
  components: {
    BButton,
    BTable,
    BasePagination,
    ViewOneSubscriptionPlan,
    BCard,
    BOverlay,
    BModal,
    BSpinner,
    vSelect,
    BFormGroup,
    BBadge,
    BFormCheckbox,
    BRow,
    BCol,
  },
  setup(_, ctx) {
    return {
      ...useSubscription(ctx),

    }
  },
}
</script>
